import { useContext } from 'react';
import { RootStoreContext } from 'stores/root_store';

const useStores = () => {
    return useContext(RootStoreContext);
};

export default useStores;
